export const DATE_TIME_FORMATS: DateTimeFormatsInterface = {
  BACKEND_TIME: 'HH:mm:ss.SSS[Z]',
  DATE: 'YYYY-MM-DD',
  DATE_DAY: 'ddd DD MMM',
  DATE_LONG: 'd MMM yyyy',
  DATE_TIME: 'YYYY-MM-DD - HH:mm',
  DATE_TIME_LONG: 'DD MMM YYYY HH:mm[Z]',
  DATE_TIME_LONG_NO_ZONE: 'YYYY MMM DD - HH:mm',
  DATE_TIME_LONG_NO_ZONE_FORMAT: 'eee dd MMM yyyy - HH:mm',
  END_TIME_OF_DAY: '23:59',
  SHORT_DATE: 'd MMM',
  START_TIME_OF_DAY: '00:00',
  TIME: 'HH:mm',
  TIME_DATE: 'HH:mm - dd MMM yyyy',
};

export interface DateTimeFormatsInterface {
  BACKEND_TIME: string;
  DATE: string;
  DATE_DAY: string;
  DATE_LONG: string;
  DATE_TIME: string;
  DATE_TIME_LONG: string;
  DATE_TIME_LONG_NO_ZONE: string;
  DATE_TIME_LONG_NO_ZONE_FORMAT: string;
  END_TIME_OF_DAY: string;
  SHORT_DATE: string;
  START_TIME_OF_DAY: string;
  TIME: string;
  TIME_DATE: string;
}
